import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const CertificationsAndPartnerPrograms_MultiListCard = () => {

    const cardDetaisl = [
        {
            title: "Certifications & Audit Alignment",
            list: [
                {
                    list1: "Security frameworks:",
                    content: "SOC 2 (Type I/II) alignment, ISO 27001 control mapping; ISO 27701 (privacy) roadmap"
                },
                {
                    list1: "Privacy & regulation:",
                    content: "GDPR/DPDP readiness; DPA/SCCs; DPIA templates"
                },
                {
                    list1: "Cloud posture:",
                    content: "CIS benchmarks baseline; hardened images; IaC controls & drift detection"
                },
                {
                    list1: "Assurance:",
                    content: "Annual 3rd-party pentest; quarterly scans; policy attestation (artifacts under NDA)"
                }
            ]
        },
        {
            title: "Technology Partners & Integrations",
            list: [
                {
                    list1: "Cloud:",
                    content: "AWS • Microsoft Azure • Google Cloud"
                },
                {
                    list1: "Enterprise platforms:",
                    content: "Salesforce • ServiceNow • SharePoint • NetSuite • Oracle"
                },
                {
                    list1: "AI stack:",
                    content: "OpenAI • Google (Gemini) • open-weight models • vector DBs • observability (OTel/Langfuse)"
                },
                {
                    list1: "Data & messaging:",
                    content: "Kafka • Redis • PostgreSQL/MySQL • Snowflake/BigQuery • REST/GraphQL"
                },
                {
                    list1: "DevOps & security:",
                    content: "Kubernetes • Terraform • Vault/KMS • Cloudflare/WAF • CI/CD (GitHub/Jenkins)"
                },
                {
                    list1: "Web & mobile:",
                    content: "React/Vue • Flutter; identity via OIDC/SSO providers"
                }
            ]
        }
    ]

    return (
        <>
            <Row>
                {
                    cardDetaisl.map((item, index) => {
                        return (
                            <Col className='card_margin' lg="6" key={index}>  
                                <Card className='multi_list_card'>
                                    <Card.Title className='multi_list_card_content_title'>{item.title}</Card.Title>
                                    <div className='multi_list_card_content'>
                                        <ul>
                                            {
                                                item.list.map((newitem, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {newitem.list1}
                                                            <p className='list_subitem'>{newitem.content}</p>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default CertificationsAndPartnerPrograms_MultiListCard